module.exports = __webpack_public_path__ + "static/media/in_a_week_9.54f4e99f.jpg";